import user from 'utils/extra/user';
import { IS_PPP } from 'utils';

export default function getAppBasename() {
  if (!IS_PPP) return '/';
  // PPP app: URL shape is /sellerID/storeID/...
  // Set basename so all internal routes remain relative (e.g. /login, /account/orders)
  // without needing to know the sellerID/storeID prefix.
  const { sellerID, storeID } = user.getPPPIdsFromURL();
  if (sellerID && storeID) return `/${sellerID}/${storeID}`;
  if (sellerID) return `/${sellerID}`;
  return '/';
}
